import { Component } from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {UserService} from "../../../@core/services/user.service";
import {USM_USR_14} from "../../../@shared/models/input.module";
import {CommonModule} from '@angular/common';
import {TranslateModule} from "@ngx-translate/core";

// Password strength validator
function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const hasNumber = /[0-9]/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    const hasMinLength = value.length >= 8;

    const valid = hasNumber && hasSpecialChar && hasMinLength;

    return valid ? null : { passwordStrength: true };
  };
}

// Password match validator
function passwordMatchValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');

    if (!password || !confirmPassword) {
      return null;
    }

    return password.value === confirmPassword.value ? null : { passwordMismatch: true };
  };
}

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule
  ],
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent {
  resetForm: FormGroup;
  resetToken: string;
  passwordVisible = false;
  confirmPasswordVisible = false;
  isSubmitting = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private userService: UserService) {
  }

  ngOnInit() {
    this.resetForm = new FormGroup({
      password: new FormControl('', [Validators.required, passwordStrengthValidator()]),
      confirmPassword: new FormControl('', [Validators.required])
    }, { validators: passwordMatchValidator() });

    this.route.queryParams
      .subscribe(params => {
        this.resetToken = params['reset_token'];
      });
  }

  togglePasswordVisibility(field: string) {
    if (field === 'password') {
      this.passwordVisible = !this.passwordVisible;
    } else if (field === 'confirmPassword') {
      this.confirmPasswordVisible = !this.confirmPasswordVisible;
    }
  }

  onSubmit() {
    if (this.resetForm.valid) {
      this.isSubmitting = true;
      let payload: USM_USR_14 = {
        reset_token: this.resetToken,
        new_password: this.resetForm.get('password')!.value
      }
      this.userService.setNewPassword(payload).subscribe({
        next: (response) => {
          this.router.navigate(['/auth/login']);
        },
        error: (error) => {
          this.isSubmitting = false;
        }
      });
    }
  }
}
